import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  fullWidth: {
    width: '100%',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  fullHeight: {
    flex: 1,
    height: '100%',
  },
  center: {
    justifyContent: 'center',
  },
  dontCenter: {
    alignItems: 'flex-start',
  },
}));

export const Row = (props) => {
  const { center, dontCenter, children, className, fullWidth } = props;

  const classes = styles();

  return (
    <div {...props} className={clsx(classes.row, center && classes.center, dontCenter && classes.dontCenter, fullWidth && classes.fullWidth, className)}>
      {children}
    </div>
  );
};

export const Column = (props) => {
  const { center, children, className, fullHeight, fullWidth } = props;

  const classes = styles();

  return (
    <div {...props} className={clsx(classes.column, center ? classes.center : classes.dontCenter, fullWidth && classes.fullWidth, fullHeight && classes.fullHeight, className)}>
      {children}
    </div>
  );
};
